import isString from 'lodash-es/isString';
/**
 * The whole sender_phone may not be an object or a string but null, if the user did not registered it
 */
export const sendableFromRaw = ({ sender_phone, sender_name, sender_email }) => ({
    senderName: sender_name,
    senderEmail: sender_email,
    senderPhoneCountry: isString(sender_phone) ? null : sender_phone?.country,
    senderPhoneNumber: isString(sender_phone) ? sender_phone : sender_phone?.number
});
